export default {
  nav: {
    portfolio: "Portofolio Widyo",
    whyme: "Mengapa Saya?",
    education: "Pendidikan",
    experience: "Pengalaman",
    organizational: "Organisasi",
    events: "Event",
    portfolio_link: "Portofolio",
    skills: "Keterampilan",
    certificates: "Sertifikat",
    awards: "Penghargaan",
    contact: "Kontak",
    downloadResume: "Unduh Resume",
    downloadPortfolio: "Unduh Portofolio",
    letsConnect: "Mari Terhubung",
  },
  hero: {
    greeting: "Halo!",
    name: "Saya Widyo Tri Cahya Utomo",
    nickname: "Dio",
    title: "DevOps Engineer | Data Engineer",
    description: "DevOps Engineer di Apple Developer Institute, mengotomasi infrastruktur AWS sebagai kode dengan Terraform dan Ansible serta membangun pipeline CI/CD. Berbekal tiga tahun rekayasa data perusahaan — ETL/CDC, migrasi cloud, dan platform data.",
    downloadResume: "Unduh Resume",
    contactMe: "Hubungi Saya",
  },
  whyme: {
    title: "Mengapa Saya?",
    subtitle: "Apa yang membuat saya berbeda sebagai DevOps Engineer",
    content: "Saya tidak hanya memindahkan data — saya mengubahnya menjadi kecerdasan yang menciptakan nilai bisnis nyata. Saya mendekati setiap masalah dengan skeptisisme yang penuh rasa ingin tahu, memvalidasi asumsi dan merancang sistem yang dapat berkembang, tetap andal, dan benar-benar memberikan hasil. Pengalaman saya mencakup data engineering end-to-end, termasuk ingestion, warehousing, orchestration, governance, dan performance tuning di berbagai stack modern. Saya telah bekerja di lingkungan enterprise di mana kegagalan bukan pilihan, sehingga reliabilitas, keamanan, dan presisi adalah hal yang tidak bisa ditawar. Saya terobsesi dengan arsitektur yang bersih, pipeline yang efisien, dan otomasi yang mencegah masalah — bukan menyebabkannya. Dengan 40+ sertifikasi industri dan fokus berorientasi masa depan pada AI dan Web3, saya membangun sistem yang dirancang untuk tuntutan hari ini dan inovasi masa depan. Singkatnya, saya memberikan solusi data yang dibangun untuk dampak, dibangun untuk skala, dan dibangun untuk masa depan.",
  },
  tools: {
    title: "Berikut adalah beberapa alat dan teknologi yang saya gunakan setiap hari",
  },
  education: {
    title: "Pendidikan",
    subtitle: "Fondasi akademis dalam Teknik Komputer dengan fokus kuat pada sistem data",
    graduated: "Lulus",
    institutions: {
      maranatha: {
        name: "Universitas Kristen Maranatha",
        degree: "Sarjana Teknik (S.T.), Teknik Komputer",
        highlights: [
          "IPK: 3.83",
          "Mata kuliah relevan: Basis Data, Sistem Operasi, Jaringan Komputer",
        ],
      },
      yosuka: {
        name: "SMA Yos Sudarso - Karawang",
        degree: "Jurusan Matematika & Sains",
        status: "Ijazah SMA",
      },
      akademicrypto: {
        name: "Akademi Crypto - Tangerang",
        degree: "Program Non-Gelar dalam Web3 dan Blockchain",
        status: "Mar 2024 - Sekarang",
        highlights: [
          "Fokus pada Web3, Fundamental Blockchain, dan Teknologi Terdesentralisasi",
          "Pembelajaran aktif dalam ekonomi kripto, smart contracts, dan ekosistem DeFi",
        ],
      },
      tradewithsuli: {
        name: "TradeWithSuli - Jakarta",
        degree: "Program Non-Gelar dalam Trading Finansial dan Analisis Pasar",
        status: "Sep 2025 - Sekarang",
        highlights: [
          "Fokus pada trading cryptocurrency menggunakan analisis fundamental dan teknikal",
          "Mengembangkan strategi trading praktis dan keterampilan evaluasi pasar melalui pembelajaran komunitas",
        ],
      },
    },
  },
  experience: {
    title: "Pengalaman",
    subtitle: "Otomasi infrastruktur cloud, serta rekayasa data perusahaan dan konsultasi teknis di berbagai industri",
  },
  organizational: {
    title: "Organisasi & Komunitas",
    subtitle: "Peran kepemimpinan dan partisipasi aktif dalam organisasi profesional dan komunitas",
    activities: [
      {
        title: "Kepemimpinan Universitas",
        organization: "Universitas Kristen Maranatha",
        role: "Kepala Lab Komputer Digital",
        dates: "Apr 2021 – Apr 2023",
        description: "Memimpin lab, mengelola proyek dan pembimbingan mahasiswa.",
      },
      {
        title: "Komunitas Kripto",
        organization: "Akademi Crypto, TradeWithSuli, Coin Kami",
        role: "Anggota Aktif",
        dates: "Feb 2023 - Sekarang",
        description: "Partisipan aktif dan pembelajar seumur hidup di komunitas Web3 dan kripto.",
      },
      {
        title: "Connect Group dan Pelayanan Multimedia",
        organization: "Gereja Rose of Sharon",
        role: "Anggota Aktif",
        dates: "Agu 2015 - Sekarang",
        description: "Terlibat aktif dalam komunitas gereja melalui persekutuan Connect Group dan melayani di Pelayanan Multimedia, mendukung kebaktian dan produksi media kreatif.",
      },
    ],
  },
  events: {
    title: "Event & Galeri",
    subtitle: "Foto dan sorotan dari berbagai event, konferensi, seminar, dan kegiatan profesional",
    noImages: "Belum Ada Event",
    maintenance: "Dalam Pemeliharaan",
    maintenanceDesc: "Belum ada event yang ditambahkan. Silakan cek kembali nanti!",
  },
  portfolio: {
    title: "Portofolio",
    subtitle: "Proyek terpilih yang menampilkan pengembangan web dan pekerjaan rekayasa data",
    webPortfolioTitle: "Portofolio Web",
    dataPortfolioTitle: "Portofolio Data Engineering",
    viewLive: "Lihat Langsung",
    explore: "Jelajahi",
    showMore: "Tampilkan Lebih Banyak",
    showLess: "Tampilkan Lebih Sedikit",
    downloadPdf: "Unduh Portofolio sebagai PDF",
    generatingPdf: "Membuat PDF...",
    selectProjects: "Pilih Proyek",
    selectAll: "Pilih Semua",
    cancel: "Batal",
    downloadSelected: "Unduh",
    webProjects: [
      {
        title: "Mapan Furniture",
        description: "Maju Mapan adalah merek furniture modern yang memadukan desain elegan dengan keberlanjutan. Setiap piece dibuat dengan tangan oleh pengrajin lokal menggunakan material ramah lingkungan — membawa kenyamanan, keseimbangan, dan kehangatan ke setiap ruang hidup.",
      },
      {
        title: "Tcuber Store",
        description: "Tcuber Store adalah platform top-up game online terpercaya di Indonesia, menyediakan kredit digital yang cepat, aman, dan terjangkau untuk game populer seperti Mobile Legends, Free Fire, Roblox, Genshin Impact, Clash of Clans, dan PUBG Mobile. Kami menawarkan berbagai metode pembayaran dan dukungan responsif untuk memastikan pengalaman gaming yang lancar.",
      },
    ],
    dataProjects: [
      {
        title: "Analisis Data Penguin dengan AI",
        description: "Alat eksplorasi data interaktif yang didukung oleh AI. Analisis data spesies penguin dengan pertanyaan bahasa natural dan visualisasi insight melalui chart dinamis. Dibangun dengan React, Recharts, dan Lovable AI.",
      },
    ],
    penguinExplorer: {
      title: "Tanya tentang Penguin",
      selectQuestion: "Apa yang ingin Anda ketahui?",
      submit: "Kirim",
      analyzing: "Menganalisis...",
      thinking: "Berpikir...",
      errorLoading: "Gagal memuat data penguin",
      errorAnalyzing: "Gagal menganalisis data",
      rateLimitError: "Batas kecepatan terlampaui. Silakan coba lagi nanti.",
      paymentError: "Diperlukan pembayaran. Silakan tambahkan kredit ke workspace Lovable AI Anda.",
      speciesDistribution: "Distribusi Spesies",
      billVsBody: "Panjang Paruh vs Massa Tubuh",
      dataTable: "Pratinjau Data",
      questions: [
        "Penguin mana yang memiliki panjang paruh terpanjang?",
        "Di mana penguin paling berat tinggal?",
        "Penguin mana yang memiliki sirip terpendek?",
      ],
    },
  },
  skills: {
    title: "Keterampilan",
    subtitle: "Infrastruktur cloud, otomasi, dan CI/CD, di atas fondasi rekayasa data perusahaan",
    categories: {
      cloud: "Cloud & Infrastruktur",
      iac: "IaC & GitOps",
      cicd: "CI/CD",
      containers: "Container & Observability",
      security: "Keamanan & Jaringan",
      databases: "Basis Data",
      etl: "ETL & Integrasi",
      programming: "Pemrograman",
      soft: "Soft Skill",
    },
  },
  certificates: {
    title: "Sertifikat Dataiku",
    subtitle: "Sertifikasi profesional dalam data science, machine learning, dan AI dari Dataiku",
    clickToView: "Klik untuk melihat sertifikat lengkap",
    download: "Unduh",
    verify: "Verifikasi",
    preview: "Pratinjau Sertifikat",
  },
  awards: {
    title: "Penghargaan & Sertifikasi",
    subtitle: "Sertifikasi profesional di platform data, infrastruktur cloud, dan teknologi AI",
    view: "Lihat",
  },
  contact: {
    title: "Hubungi Kami",
    subtitle: "Terbuka untuk peluang, kolaborasi, dan permintaan berbicara",
    info: "Informasi Kontak",
    email: "Email",
    phone: "Telepon",
    social: "Media Sosial",
    sendMessage: "Kirim Pesan",
    name: "Nama",
    namePlaceholder: "Masukkan nama",
    emailPlaceholder: "Masukkan email",
    message: "Pesan",
    messagePlaceholder: "Masukkan pesan",
    send: "Kirim Pesan",
    copyright: "© 2025 Widyo Tri Cahya Utomo. Semua hak dilindungi.",
  },
  whatsapp: {
    title: "Mari Terhubung",
    subtitle: "Pilih cara Anda ingin menghubungi saya",
    chatbot: "Chat dengan Asisten AI",
    whatsapp: "Pesan via WhatsApp",
    defaultMessage: "Halo Widyo! Saya ingin terhubung dengan Anda.",
  },
  chatbot: {
    title: "Asisten AI",
    welcome: "Halo! Saya asisten AI Widyo. Saya bisa menjawab pertanyaan tentang pengalaman, keahlian, dan proyeknya. Bagaimana saya bisa membantu Anda?",
    placeholder: "Ketik pesan Anda...",
    error: "Maaf, terjadi kesalahan. Silakan coba lagi.",
  },
};
